
const EN = window.EN;
const EN_KO = window.EN_KO;

import User from './../libs/User.js';
import renderProductListItem from './templates/product-list-item.tpl.html';

class FactfinderProductList {

	constructor( productListEl ) {
		this.productListEl = productListEl;
	}

	isOnWishlist( userdata, sku ) {
		const user = userdata?.data?.user;
		const wishlist = user.wishlist || [];

		const itemCount = wishlist.find( ( item ) => item.aid === sku )?.amt || 0;
		return itemCount > 0;
	}

	getWishlistLink( userdata, sku ) {
		const user = userdata?.data?.user;

		if ( ! user?.loggedIn ) {
			return '/mein-konto/';
		}

		const params = new URLSearchParams( {
			'cl': 'account_noticelist',
			'fnc': 'addArticleToNoticeList',
			'aid': sku,
			'amt': this.isOnWishlist( userdata ) ? 1 : 0,
			'stoken': user.stoken,
		} );

		return '/index.php?' + params.toString();
	}

	async update( {hits} ) {

		return User.getData()
			.then( userdata => {
				return Promise.all(
					// Render each item asynchronously.
					hits.map( ( hit ) => {
						const sku = hit.variantValues[0].ProductID;
						const wishlistLink = this.getWishlistLink( userdata, sku );
						const onWishlist = this.isOnWishlist( userdata, sku );
						return EN.Render.render( 'product-list-item', { hit: this.getProduct( hit ), userdata, onWishlist, wishlistLink } );
					} )
				).then( ( productHtml ) => {
					// Then join the resulting html.
					this.productListEl.innerHTML = productHtml.join( '' );
				} )
			}
			);
	}

	getProduct( hit ) {

		const { masterValues, variantValues } = hit;
		const master = masterValues;
		const variant = variantValues[0];
		const primaryImage = variant.ImageURL;
		const link = EN_KO.functions.make_link_relative( variant.ProductURL );
		const color = ( variant.Color && ( variant.Color[0].split( '$' )[0] + '$$' + master.Artikelnummer ) ) ?? false;
		const colorLabel = color ? color.split( '$$' )[0] : 'Keine Farbe';

		const isSale = !!variant.salesrange;
		const isNew = variant.new && ( variant.new[0] === 'true' );
		const onlineOnly = variant.online_only && ( variant.online_only[0] === '1' );

		const splitInTwo = ( attr, divider = '=' ) => {
			const index = attr.indexOf( divider );
			return [ attr.slice( 0, index ), index === -1 ? '' : attr.slice( index + 1 ) ].map( str => str.trim() );
		};

		const imageAttributes = ( Array.isArray( variant.imageAttributes ?? [] ) ? ( variant.imageAttributes ?? [] ) : variant.imageAttributes.split( '|' ).filter( attr => !!attr ) ).map( ( attr ) => splitInTwo( attr, '=' ) ) ;
		const linkAttributes  = ( Array.isArray( variant.linkAttributes ?? [] ) ? ( variant.linkAttributes ?? [] ) : variant.linkAttributes.split( '|' ).filter( attr => !!attr ) ).map( ( attr ) => splitInTwo( attr, '=' ) );

		const badges = this.getBadges( variant.badges ?? [] );

		let discountPercent = 0;
		if ( isSale ) {
			discountPercent = Math.trunc( ( variant.Price_old - variant.Price ) / variant.Price_old * 100 * -1 );
		}

		let colorSizes = {};
		( variant.AvailableSizes || [] ).forEach( availableSize => {
			const [color, size] = splitInTwo( availableSize );

			if ( color && size ) {
				colorSizes[color] ??= [];
				if( !colorSizes[color].includes( size ) ) {
					colorSizes[color].push( size );
				}
			}
		} );

		Object.keys( colorSizes ).forEach( key => {
			if ( colorSizes[key].length > 15 ) {
				colorSizes[key] = [ 'In vielen Größen verfügbar' ];
			}
		} );

		const images = [
			primaryImage,
			...( variant.articleImages ? variant.articleImages.split( ',' ).filter( image => image !== '' ) : '' )
		];

		const initialSizes = ( !color && Object.keys( colorSizes ).length === 1 ) ? ( colorSizes[Object.keys( colorSizes )[0]] ?? [] ) : ( color ? ( colorSizes[color] ?? [] ) : [] );

		const colorDots = [
			// Current Color.
			[color, primaryImage, link, initialSizes],

			// Variations.
			...imageAttributes.map( ( [varColor, varImage] ) => {
				const varLink = linkAttributes.find( ( [color1] ) => varColor === color1 ) ?? [];
				const varSizes = colorSizes[varColor];
				return [varColor, varImage, EN_KO.functions.make_link_relative( varLink[1] ?? variant.Deeplink ), varSizes];
			} )
		];

		return {
			...hit,
			renderData: {
				link,
				color,
				colorLabel,
				isNew,
				isSale,
				onlineOnly,
				badges,
				discountPercent,
				images,
				initialSizes,
				colorDots
			}
		};
	}

	getBadges( jsonBadges ) {
		const specialBadges = [ 'coming_soon' ];

		if ( 'string' !== typeof jsonBadges ) {
			return jsonBadges || [];
		}

		if ( ! jsonBadges ) {
			return [];
		}

		jsonBadges = jsonBadges.replace( /'/g, '"' );
		let tempBadges = [];
		try {
			tempBadges = JSON.parse( jsonBadges );
		} catch ( ex ) { // eslint-disable-line no-unused-vars
			return [];
		}

		if ( tempBadges.length <= 0 ) {
			return [];
		}

		const ACL_BADGE_DEFS = window.ACL_BADGE_DEFS;
		return tempBadges.map( badge => {
			if ( ACL_BADGE_DEFS[ badge.name ] ?? false ) {
				return ACL_BADGE_DEFS[ badge.name ];
			}
			badge.title = decodeURIComponent( badge.title );
			return badge;
		} ).filter( ( badge ) => ! specialBadges.includes( badge.name ) );
	}

}

EN.Render.addTemplate( 'product-list-item', renderProductListItem );

export default FactfinderProductList;
